import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import { SourceService } from 'mangools-commons/dist/services/SourceService';

import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import { parseIndex, parseDetail } from 'sources/parsers/ListDataParser';

// Constants
const ENDPOINT = '/lists';

/**
 * Data source class handling communication with API for keyword lists data.
 */
class ListSource extends SourceService {
    static getData(accessToken) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.KWFINDER_API_PATH}${ENDPOINT}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parseIndex(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }

    static getDetail({ listId, accessToken }) {
        const request = ListSource.createRequest({
            method: 'GET',
            parse: parseDetail,
        });

        return request({
            requestURL: `${APP_CONFIG.API_HOST}${APP_CONFIG.KWFINDER_API_PATH}${ENDPOINT}/${listId}`,
            headers: {
                'X-Access-Token': accessToken,
            },
        });
    }
}

export default ListSource;
